export type { ConsentType } from './Cookiebot';
export { CookieConsent } from './Cookiebot';
export { useCookieBot } from './hooks/useCookieConsent/useCookieBot';
